export default __webpack_public_path__ + "static/Sidebar_desktop_CME_Logo_Green-2cb8c684a689aed56620495b88f76204.svg";